import * as React from 'react';
import { TitleWithWbr } from '@/components/domain/common/TitleWithWbr';
import './table.css';

interface TableDataItem {
  date: string;
  activity: string;
}

export type TableData = Array<TableDataItem>;

interface TableProps extends React.HTMLAttributes<HTMLTableElement> {
  data: TableData;
  onRowClick?: (
    rowNumber: number,
  ) => React.MouseEventHandler<HTMLTableRowElement>;
}

const TableContent: React.FC<TableProps> = ({ data, onRowClick }) => {
  return (
    <>
      {data.map((item, index) => {
        return (
          <tr key={`${index}_${item.activity}`} onClick={onRowClick?.(index)}>
            <td>
              <TitleWithWbr>{item.date}</TitleWithWbr>
            </td>
            <td>{item.activity}</td>
          </tr>
        );
      })}
    </>
  );
};

const TableEmptyState: React.FC = () => {
  return (
    <tr className="empty">
      <td colSpan={2}>There's no recent activity</td>
    </tr>
  );
};

const Table = React.forwardRef<HTMLTableElement, TableProps>(
  ({ data, onRowClick, ...props }, ref) => {
    return (
      <table className="table" ref={ref} {...props}>
        <thead>
          <tr>
            <th scope="col">Date</th>
            <th scope="col">Activity</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            <TableContent data={data} onRowClick={onRowClick} />
          ) : (
            <TableEmptyState />
          )}
        </tbody>
      </table>
    );
  },
);

export { Table };
